import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { Briefcase, PlayCircle, Clock, CheckCircle2, AlertTriangle, DollarSign } from 'lucide-react';

export function ProjectsKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng Dự Án',
      value: 45,
      suffix: 'Dự án',
      icon: Briefcase,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Năm nay',
      chartColor: 'bg-indigo-500',
      chartData: [35, 38, 40, 42, 42, 44, 45]
    },
    {
      title: 'Đang Thi Công',
      value: 18,
      suffix: 'Dự án',
      icon: PlayCircle,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Hoạt động',
      chartColor: 'bg-blue-500',
      chartData: [12, 14, 15, 16, 17, 18, 18]
    },
    {
      title: 'Chậm Tiến Độ',
      value: 3,
      suffix: 'Cảnh báo',
      icon: AlertTriangle,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'down',
      trendValue: 'Đã xử lý 1',
      chartColor: 'bg-rose-500',
      chartData: [5, 5, 4, 4, 3, 3, 3]
    },
    {
      title: 'Chờ Bàn Giao',
      value: 5,
      suffix: 'Dự án',
      icon: Clock,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'up',
      trendValue: 'Giai đoạn cuối',
      chartColor: 'bg-amber-500',
      chartData: [2, 3, 3, 4, 4, 5, 5]
    },
    {
      title: 'Đã Bàn Giao',
      value: 19,
      suffix: 'Dự án',
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Năm nay',
      chartColor: 'bg-emerald-500',
      chartData: [10, 12, 14, 15, 16, 18, 19]
    },
    {
      title: 'Tổng Ngân Sách',
      value: 450,
      suffix: 'Tỷ',
      icon: DollarSign,
      color: 'text-slate-600',
      bg: 'bg-slate-100',
      trend: 'up',
      trendValue: 'Dự kiến',
      chartColor: 'bg-slate-500',
      chartData: [380, 400, 410, 420, 430, 440, 450]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
